<template>
    <div>
        <label class="label__variable">{{ name }}</label>
        <input type="text" disabled v-model="value">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['name', 'initialValue'],
    data () {
        return {
            value: this.initialValue
        }
    },
    methods: {
        getValue () {
            return this.value
        }
    }
}
</script>
